import axios from 'axios';

import RequestHeadersBase from '~/common/constants/RequestHeadersBase';
import { handleRefreshInterceptor } from '~/services/interceptors/handle-refresh.interceptor';
import { setAuthTokenInterceptor } from '~/services/interceptors/set-auth-token.interceptor';
import {
  GeoComplyReasonCode,
  GeoComplyTokenType,
  Method,
  setLocationInterceptor,
} from '~/services/interceptors/set-location.interceptor';

export const marketServiceInstance = axios.create({
  baseURL: `${process.env.NEXT_PUBLIC_API_URL_SPLASH}predictions-service/api`,
  headers: {
    ...RequestHeadersBase,
  },
});

setAuthTokenInterceptor(marketServiceInstance);
handleRefreshInterceptor(marketServiceInstance);
setLocationInterceptor(marketServiceInstance, [
  [
    Method.POST,
    '/orders',
    { reasonCode: GeoComplyReasonCode.PURCHASE_WAGER, tokenType: GeoComplyTokenType.VALID },
  ],
]);
